import { maskCNPJ } from '../../lib/masks';

const DEFAULT_CLASS =
  'mt-1 w-full rounded-lg border border-mbc-line bg-mbc-panel2 px-3 py-2 text-sm text-white focus:border-mbc-orange focus:outline-none';

interface CnpjInputProps {
  /** CNPJ mascarado (ex.: "11.222.333/0001-81"). */
  value: string;
  /** Recebe o novo CNPJ já mascarado. */
  onChange: (masked: string) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
}

/** Input de CNPJ com máscara progressiva 00.000.000/0000-00. */
export function CnpjInput({ value, onChange, className, placeholder, disabled }: CnpjInputProps) {
  return (
    <input
      type="text"
      inputMode="numeric"
      maxLength={18}
      value={value}
      onChange={e => onChange(maskCNPJ(e.target.value))}
      className={className ?? DEFAULT_CLASS}
      placeholder={placeholder ?? '00.000.000/0000-00'}
      disabled={disabled}
    />
  );
}
